import update from 'immutability-helper';

import { mapOffices } from 'utils/set-takeaway-offices';

import {
  SET_DELIVERY_ACTIVE_BUTTON,
  SET_DELIVERY_SORT_DIRECTION,
  SET_DELIVERY_POINTS_TO_SHOW,
  HIDE_DELIVERY_POINTS_TO_SHOW,
  SET_INITIAL_OFFICES,
  SET_TAKEAWAY_FILTERS,
  SET_PRODUCT_DETAILS_OFFICES,
  SET_PRODUCT_DETAILS_OFFICES_RAW,
  SET_BASKET_ID,
  SET_ORDER_INFO,
  SET_ORDER_LOADING,
} from './constants';
import { SET_DELIVERY_TAKEAWAY_VIEW } from '../common/constants';

const initialState = {
  basketId: null,
  orderInfo: null,
  deliveryPointsLoading: null,
  orderInfoLoading: true,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_DELIVERY_ACTIVE_BUTTON: {
      const { slug } = action;
      return update(state, {
        sortWidgetState: {
          activeButton: { $set: slug },
        },
      });
    }
    case SET_DELIVERY_SORT_DIRECTION: {
      const { reverse } = action;
      return update(state, {
        sortWidgetState: {
          reverse: { $set: !reverse },
        },
      });
    }
    case SET_DELIVERY_POINTS_TO_SHOW: {
      const { pointsCount } = action;
      return update(state, {
        officesToShow: { $set: pointsCount },
      });
    }
    case HIDE_DELIVERY_POINTS_TO_SHOW: {
      const { pointsCount } = action;
      return update(state, {
        officesToShow: { $set: pointsCount },
      });
    }
    case SET_DELIVERY_TAKEAWAY_VIEW: {
      const { view } = action;
      return update(state, {
        sortWidgetState: {
          currentView: { $set: view },
        },
      });
    }
    case SET_INITIAL_OFFICES: {
      const { allOffices } = action;
      return {
        ...state,
        allOffices,
      };
    }
    case SET_PRODUCT_DETAILS_OFFICES: {
      const { offices: unmappedOffices } = action;
      return {
        ...state,
        takeaway: {
          ...state.takeaway,
          offices: mapOffices(unmappedOffices),
        },
      };
    }
    case SET_PRODUCT_DETAILS_OFFICES_RAW: {
      return {
        ...state,
        takeaway: {
          ...state.takeaway,
          offices: action.payload,
        },
      };
    }
    case SET_TAKEAWAY_FILTERS: {
      const { option } = action;
      return {
        ...state,
        takeaway: {
          ...state.takeaway,
          settings: {
            ...state.takeaway.settings,
            filters: state.takeaway.settings.filters.map((filter) =>
              filter.slug === option.slug ? { ...filter, ...option } : filter,
            ),
          },
        },
      };
    }
    case SET_BASKET_ID: {
      return {
        ...state,
        basketId: action.payload,
      };
    }
    case SET_ORDER_INFO: {
      return {
        ...state,
        orderInfo: action.payload,
      };
    }
    case SET_ORDER_LOADING: {
      return {
        ...state,
        orderInfoLoading: action.payload,
      };
    }
    default:
      return state;
  }
}
